/* eslint-disable no-unused-vars */
import React from 'react'
import Link from 'next/link'
import { Button, Input, Row } from 'antd'
import { useWindowSize } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import { CustomCol, CustomTitle } from 'src/components'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'

interface OfferGroupSaleOfferHeaderProps {
  filterText: string
  handleChange: (value: string) => void
  length: number
}

const OfferGroupSaleOfferHeader: React.FC<OfferGroupSaleOfferHeaderProps> = (props) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return (
    <Row>
      <CustomCol lg={10}>
        <CustomTitle
          label={t('SalesOffer.GroupLength', { length: props.length })}
          type={null}
        />
      </CustomCol>
      <CustomCol lg={8}>
        <Input
          allowClear
          value={props.filterText}
          onChange={(e) => {
            const text = e.target.value
            props.handleChange(text)
          }}
          placeholder={t('Withdrawals.Filter')}
          prefix={<SearchOutlined />}
        />
      </CustomCol>
      <CustomCol lg={6}>
        <Link href={'/admin/create-sale-offer'} passHref>
          <Button
            icon={<PlusOutlined />}
            type='dashed'
            block={isMobile}
            className={isMobile ? 'mt-3' : 'ml-3'}
          >
            {t('SalesOffer.CreateSale')}
          </Button>
        </Link>
      </CustomCol>
    </Row>
  )
}

export default OfferGroupSaleOfferHeader
